export default "/institutions/brand-amex.svg";